 import './GridOptions.css'
 import './GridResults.css'
 import './GridTable.css'
 import { on, ready, query, queryAll } from '../../lib/dom.js'
 import { show, hide, toggleClass, resetUrlQuery, getJSON, addQueryParamUrl, fireEvent } from '../../lib/jsfunc.js'

// Eigenschaften-Bereich zurücksetzen
export function resetSelection() {
  var eigenschaften = query('.GridOptions');

  [].forEach.call( queryAll(eigenschaften, '.image'), function(img) {
    img.classList.add('active');
    show(img);
  });
  
  [].forEach.call( queryAll(eigenschaften, '.image-selected'), function(img) {
    img.classList.remove('active');
    img.classList.remove('visible');
    hide(img);
  });
  
  [].forEach.call( queryAll(eigenschaften, 'select:not(.grid-kategorie),input'), function(elem) {
    var defaultValue = elem.getAttribute('data-default');
    elem.value = defaultValue ? defaultValue : '';
  });
}


// Eigenschaften-Bereich an Grid-Auswahl anpassen
export function updateEigenschaften(event) {
  var name, value;
  var eigenschaftenSelect, eigenschaftenInput, eigenschaftenValue;
  name = event.target.getAttribute('name');
  
  // _val und _op abschneiden
  if(name.indexOf('_') > 0){
    name = name.substr(0, name.indexOf('_'));
  }
  value = event.target.value;
  
  if(event.target.tagName == 'SELECT'){
    eigenschaftenSelect = query('.GridOptions select.'+name);
    if(eigenschaftenSelect){
      eigenschaftenValue = eigenschaftenSelect.value;
      if(eigenschaftenValue != value){
        eigenschaftenSelect.value = value;
        fireEvent(eigenschaftenSelect, 'change');
      }
    }
  }else if (event.target.tagName == 'INPUT'){
    eigenschaftenInput = query('.GridOptions input.'+name);
    if(eigenschaftenInput){
      eigenschaftenValue = eigenschaftenInput.value;
      if(eigenschaftenValue!=value){
        eigenschaftenInput.value = value;
        fireEvent(eigenschaftenInput, 'change');
      }
    }
  }
}

// Filter zurücksetzen (Eigenschaften und Grid-Select Boxen)
export function resetGrid(event) {
  var table, fields;
  table = query('.GridTable');
  
  [].forEach.call( queryAll(table, '.operator input, .value input'), function(elem) {
    elem.value = elem.defaultValue;
  });
  
  [].forEach.call( queryAll(table, '.operator select option, .value select option'), function(elem) {
    elem.value = elem.defaultValue;
    if (elem.defaultSelected) {
      elem.parentNode.value = elem.value;
    }
  });
  
  resetSelection();
  resetUrlQuery();
  
  getJSON(table.getAttribute('data-json-reseturl'), {nonce: nextNonce(table)}).then(function(data) {
    updateTable(data, table);
  });
}

export function resetGridEigenschaften(event) {
  var table = query('.GridTable');
  [].forEach.call( queryAll(table, '.label th:last-child,.reset'), function(elem){
    fireEvent(elem, 'click');
  });
}

// Select Image and Update selectboxes
export function selectDistinct(event, val, isSelected) {
  // Selektionen aufheben
  var images = event.target.closest('div.images');
  
  [].forEach.call( queryAll(images, 'a .image-selected'), function(img) {
    img.classList.remove('active');
    hide(img);
  });

  [].forEach.call( queryAll(images, 'a .image'), function(img) {
    img.classList.add('active');
    show(img);
  });

  if(!isSelected){
    var imgs = queryAll(images, 'a[data-select="'+val+'"] .image-selected');
    [].forEach.call( imgs, function(img) {
      show(img);
      img.classList.add('active')
    });
    
    var imgs = queryAll(images, 'a[data-select="'+val+'"] .image');
    [].forEach.call( imgs, function(img) {
      hide(img);
      img.classList.remove('active')
    });
    images.getElementsByTagName('select')[0].value = val;
  }else{
    var imgs = queryAll(images, 'a[data-select="'+val+'"] .image-selected');
    [].forEach.call( imgs, function(img) {
      hide(img);
      img.classList.remove('active')
    });
    var imgs = queryAll(images, 'a[data-select="'+val+'"] .image');
    [].forEach.call( imgs, function(img) {
      show(img);
      img.classList.add('active');
    });
    images.getElementsByTagName('select')[0].value = '';
  }
}

export function selectDistincts(event) {
  event.preventDefault();
  
  var tableSelect;
  var gridcolumn, gridval;
  var value, isSelected;
  
  var a = event.target.closest('a')
  var div = event.target.closest('div');
  
  value =  a.getAttribute('data-select');
  
  isSelected = event.target.matches('.image-selected.active')
  selectDistinct(event, value, isSelected);
  gridcolumn = div.getElementsByTagName('select')[0].classList.item(0);
  
  tableSelect = query('.GridTable .value th.'+gridcolumn+' select');
  
  gridval = tableSelect.value;
  if(isSelected){
    tableSelect.value = '';
  }else{
    if( gridval != value){
      tableSelect.value = value;
    }
  }
  fireEvent(tableSelect, 'change');
}


export function selectSelect(event) {
  event.preventDefault();

  var tableSelect;
  var gridcolumn, gridval;
  var value, select, isSelected;

  select = event.target;
  isSelected = false;

  gridcolumn = event.target.classList.item(0);
  value = select.options[select.selectedIndex].value;
  selectDistinct(event,value,isSelected);
  
  tableSelect = query('.GridTable .value th.'+gridcolumn+' select');
  
  gridval = tableSelect.value;
  if( gridval != value){
    tableSelect.value = value;
    fireEvent(tableSelect,'change');
  }
}

export function select(event) {
  event.preventDefault();
  
  var tableSelect;
  var gridcolumn, gridval;
  var value, select;
  
  select = event.target;
  gridcolumn = event.target.getAttribute('name');
  
  value = select.options[select.selectedIndex].value;
  tableSelect = query('.GridTable .value th.'+gridcolumn+' select');
  
  gridval = tableSelect.value;
  if( gridval != value){
    tableSelect.value = value;
    fireEvent(tableSelect, 'change');
  }
}

export function selectOperator(event) {
  event.preventDefault();
  
  var tableSelect;
  var gridcolumn, gridval;
  var value, select;
  
  select = event.target;
  gridcolumn = event.target.getAttribute('name');
  
  value = select.options[select.selectedIndex].value;
  tableSelect = query('.GridTable .operator th.'+gridcolumn+' select');
  
  gridval = tableSelect.value;
  if( gridval != value){
    tableSelect.value = value;
    fireEvent(tableSelect, 'change');
  }
}

export function updateInput(event) {
  event.preventDefault();

  var tableInput;
  var gridcolumn, gridval;
  var value, input;

  gridcolumn = event.target.getAttribute('name');

  value = event.target.value;
  tableInput = query('.GridTable .value th.' + gridcolumn + ' input');
  gridval = tableInput.value;
  if( gridval != value){
    tableInput.value = value;
    fireEvent(tableInput, 'change');
  }
}

function getIntAttr(elem, attr, init) {
  if (elem.hasAttribute(attr)) {
    const parsed = Number.parseInt(elem.getAttribute(attr));
    if ( !Number.isNaN(parsed)) {
      return parsed;
    }
  }
  return init;
}

function nextNonce(table) { 
  const next = getIntAttr(table, 'data-snd-nonce', 0) + 1;
  table.setAttribute('data-snd-nonce', next);
  return next;
}

function isNonceValid(table, nonce) {
  const stored = getIntAttr(table, 'data-rcv-nonce', 0);
  if (nonce < stored) {
    return false;
  }
  table.setAttribute('data-rcv-nonce', nonce);
  return true;
}

export function updateData(event) {
  
  var table;
  var queryParams = {};
  
  table = query('.GridTable');
  [].forEach.call( queryAll(table, '.operator input, .operator select, .value input, .value select'), function(elem) {
    queryParams[elem.getAttribute('name')] = elem.value.trim();
  });

  var suchbegriff = document.getElementById('suchbegriff');
  if(suchbegriff && suchbegriff.value.length>0){
    queryParams['pattern'] = suchbegriff.value.trim();
  }

  queryParams['nonce'] = nextNonce(table)
  getJSON(table.getAttribute('data-json-url'), queryParams).then(function(data) {
    updateTable(data, table);
  });
}

export function updateOrderBy(event) {
  var column =  event.target.tagName == 'TH' ? event.target : event.target.closest('th');
  var table = column.closest('table');
  
  if (column.matches('.order')) {
    if (column.matches('.asc')) {
      query('input[name="order_dir"]').value = 'desc';
      addQueryParamUrl('order_dir','desc');
    } else {
      query('input[name="order_dir"]').value = 'asc';
      addQueryParamUrl('order_dir','asc');
    }
    toggleClass(column, 'asc');
    toggleClass(column, 'desc');
  } else {
    column.classList.remove('order');
    column.classList.remove('asc');
    column.classList.remove('desc');
    
    column.classList.add('order');
    column.classList.add('asc');
    addQueryParamUrl('order_dir','asc');
    
    query('input[name="order_by"]').value = column.getAttribute('data-column');
    query('input[name="order_dir"]').value = 'asc';
  }
  
  // Bisherige Sortierung zurücksetzen
  [].forEach.call(queryAll(table, 'tr.label th'), function(elem) {
    if(column!=elem){
      elem.classList.remove('order');
      elem.classList.remove('asc');
      elem.classList.remove('desc');
    }
  });
  
  addQueryParamUrl('order_by', column.getAttribute('data-column'));
  updateData(event);
}

export function updateLimit(event) {
  var span = event.target;
  var table = span.closest('table');
  
  var limitSize = query('input[name="limit_size"]');
  var limitOffset = query('input[name="limit_offset"]');
  var limitSelection = query('.limit .selection');
  
  var numSize = Number(limitSize.value);
  var numOffset = Number(limitOffset.value);
  var numSelection = Number(limitSelection.textContent);
  
  if (span.matches('.prev')) {
    limitOffset.value = ( numOffset - numSize >= 0 ? numOffset - numSize : 0);
  } else {
    limitOffset.value = ( numOffset + numSize < numSelection ? numOffset + numSize : numOffset);
  }
  addQueryParamUrl('limit_offset',limitOffset.value);
  updateData(event);
}

export function updateTable(data, table) {

  if ( !isNonceValid(table, data['nonce'])) {
    return;
  }
  
  var prev = query('tr.limit span.prev');
  data['queryParams']['limit_prev'] ? show(prev) : hide(prev);
  
  var next = query('tr.limit span.next');
  data['queryParams']['limit_next'] ? show(next) : hide(next);
  
  query('tr.limit span.from').textContent = data['queryParams']['limit_from'];
  
  query('tr.limit span.to').textContent = data['queryParams']['limit_to'];
  
  query('tr.limit span.selection').textContent = data['queryParams']['limit_selection'];
  
  query('tr.limit span.total').textContent = data['queryParams']['limit_total'];
  
  var previewPanel = query('.panel-preview');
  var contactPanel = query('.panel-contact');
  
  if(previewPanel){
    hide(previewPanel);
    if(contactPanel){
      show(contactPanel);
    }
  }
  
  if(data['html_head']){
    table.tHead.innerHTML = data['html_head'];
  }
  if(data['html_rows']){
    table.tBodies[0].innerHTML = data['html_rows'];
  }
  table.setAttribute('data-status', 'updated');
}


